import { useContext } from 'react';
import { createContext } from 'react';

import { LogoProps } from '../@types/LogoProps';

export const LogoContext = createContext<LogoProps>({} as LogoProps);

LogoContext.displayName = 'Logo';

const LogoProvider = (props: LogoProps) => <LogoContext.Provider value={props}>{props.children}</LogoContext.Provider>;

export const useLogo = () => {
	const context = useContext(LogoContext);

	return context;
};

export default LogoProvider;
